/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlackChannelEntity
 */
export interface SlackChannelEntity {
    /**
     * SlackチャンネルID
     * Slack側で管理されるチャンネルのIDそのもの。
     * @type {string}
     * @memberof SlackChannelEntity
     */
    id: string;
    /**
     * チャンネル名
     * @type {string}
     * @memberof SlackChannelEntity
     */
    name: string;
    /**
     * メンバー数
     * @type {number}
     * @memberof SlackChannelEntity
     */
    memberCounts: number;
    /**
     * プライベートチャンネルかどうか
     * プライベートチャンネルであればtrue、パブリックチャンネルであればfalse。
     * @type {boolean}
     * @memberof SlackChannelEntity
     */
    isPrivate: boolean;
}

/**
 * Check if a given object implements the SlackChannelEntity interface.
 */
export function instanceOfSlackChannelEntity(value: object): value is SlackChannelEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('memberCounts' in value) || value['memberCounts'] === undefined) return false;
    if (!('isPrivate' in value) || value['isPrivate'] === undefined) return false;
    return true;
}

export function SlackChannelEntityFromJSON(json: any): SlackChannelEntity {
    return SlackChannelEntityFromJSONTyped(json, false);
}

export function SlackChannelEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlackChannelEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'memberCounts': json['memberCounts'],
        'isPrivate': json['isPrivate'],
    };
}

export function SlackChannelEntityToJSON(json: any): SlackChannelEntity {
    return SlackChannelEntityToJSONTyped(json, false);
}

export function SlackChannelEntityToJSONTyped(value?: SlackChannelEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'memberCounts': value['memberCounts'],
        'isPrivate': value['isPrivate'],
    };
}

